// extracted by mini-css-extract-plugin
export default {"retry":"fMF_2","spinner":"R3m_I"};